import {CHANGE_DWDF, FETCH_DWDF_DATA_SUCCESS, FETCH_DWDF_DATA_ERROR, CHANGE_DATA} from "../actions/types";
import initialState from './initialState';
import {setZargen, calculateCodeValue, calculateLengthWidth, additionalCalculation, checkValue, checkNumberLength} from '../utils/helpers';

export default (prevState = initialState.DWDF, action) => {
    switch (action.type) {

        case CHANGE_DWDF:
            return prevState;

        case FETCH_DWDF_DATA_SUCCESS:
            return {...prevState, ...action.payload};

        case FETCH_DWDF_DATA_ERROR:
            return prevState;

        case CHANGE_DATA:
            const {name, value, articleName, articleID} = action.payload;
            if (articleName === 'DWDF') {
                let newState = {...prevState};
                // update value of input field
                if (Object.prototype.toString.call(name) === '[object Object]') {
                    for (const prop in name) {
                        newState[prop].CurrentValue = name[prop];
                    }
                } else {
                    newState[name].CurrentValue = value;
                }
                if (!newState.articleID) {
                    newState.articleID = articleID;
                }
                // calculate lenght, width, position on the step 1 if VAR_ABM = 0
                if (newState['VAR_ABM'].CurrentValue === '0') {
                    switch (name) {

                        case 'BREITE':
                            newState = calculateLengthWidth('BREITE', newState, 'dwdf', ['SO23', 'SO67']);
                        break;
                        case 'LAENGE':
                            newState = calculateLengthWidth('LAENGE', newState, 'dwdf', ['SO45', 'SO81'])
                        break;
                        case 'SO23':
                            newState = additionalCalculation('SO23', newState, 'dwdf', ['BREITE'], 'SO67')
                        break;
                        case 'SO67':
                            newState = additionalCalculation('SO67', newState, 'dwdf', ['BREITE'], 'SO23')
                        break;
                        case 'SO45':
                            newState = additionalCalculation('SO45', newState, 'dwdf', ['LAENGE'], 'SO81')
                        break;
                        case 'SO81':
                            newState = additionalCalculation('SO81', newState, 'dwdf', ['LAENGE'], 'SO45')
                        break;

                    }
                }
                // calculate zargen code value on the step 2
                newState.ZT.CurrentValue = calculateCodeValue(newState, 'dwdf', ['Z23', 'Z45', 'Z67', 'Z81']);
                // calculate shurzen code value on step 4
                newState.SZ.CurrentValue = calculateCodeValue(newState, 'dwdf', ['S23', 'S45', 'S67', 'S81']);

                // establish aqua grip state
                switch (name) {
                    case "OV":
                        if (newState.OV.CurrentValue === '1') {
                            newState.MISSING_AG.CurrentValue = '0';
                            newState.GT.CurrentValue = '0';
                        }
                        break;
                    case "FA":
                        if (newState.FA.CurrentValue !== '001' && newState.MISSING_AG.CurrentValue === '1') {
                            newState.MISSING_AG.CurrentValue = '0';
                            newState.GT.CurrentValue = '0';
                        }
                        break;
                    case "MISSING_AG":
                        if (newState.MISSING_AG.CurrentValue === '1') {
                            newState.GT.CurrentValue = '4';
                            newState.MISSING_GP.CurrentValue = '0';
                            newState.OV.CurrentValue = '0';
                        } else {
                            if (newState.MISSING_GP.CurrentValue === '0') {
                                newState.GT.CurrentValue = '0';
                            }
                        }
                        break;
                    case "MISSING_GP":
                        if (newState.MISSING_GP.CurrentValue === '1') {
                            newState.GT.CurrentValue = '1';
                            newState.MISSING_AG.CurrentValue = '0';
                        } else {
                            if (newState.MISSING_AG.CurrentValue === '0') {
                                newState.GT.CurrentValue = '0';
                            }
                        }
                        break;
                }

                return newState;
            }   else {
                return prevState;
            }

        default:
            return prevState;

    }
}





// WEBPACK FOOTER //
// ./src/reducers/dwdfReducer.js